/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'id-card': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.5 13.446c0 .857-.715 1.554-1.594 1.554H3.094c-.88 0-1.594-.697-1.594-1.554V5.554C1.5 4.697 2.215 4 3.094 4h13.812c.88 0 1.594.697 1.594 1.554v7.892zm-.9.12V5.434a.54.54 0 00-.547-.534H2.858a.458.458 0 00-.458.458v8.284c0 .253.205.458.458.458h14.195c.302 0 .547-.24.547-.534zM9.6 12l-.1.101h-.616l-.1-.1v-.156a1.78 1.78 0 00-1.785-1.775c-.918 0-1.678.691-1.774 1.58l-.01.15-.002.202-.1.099H4.5l-.1-.1v-.156a2.6 2.6 0 011.674-2.43 1.428 1.428 0 111.851.002 2.598 2.598 0 011.662 2.186l.01.19L9.6 12zm-1.946-3.67a.655.655 0 10-1.31-.001.655.655 0 001.31 0zm8.755 2.776a.5.5 0 01-.5.5h-3.807a.5.5 0 110-1h3.807a.5.5 0 01.5.5zm-1.602-1.927a.5.5 0 01-.5.5h-2.205a.5.5 0 110-1h2.205a.5.5 0 01.5.5z" _fill="#1D3861"/>'
  }
})
